import React from 'react'
import Banner from '../components/Banner/Banner'
import GalleryBox from '../components/GalleryBox/GalleryBox'

export default function GalleryPage() {
    return (
        <>
                <Banner />
                <GalleryBox />
        </>
    )
}
